import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import { getDateOnlyUa } from '../../../../../helpers/date/dateHelper'
import { statusDeliverText } from '../../../../../helpers/status/StatusSupplyOrderHelper'
import Status from '../../../../UI/status/Status'
import SupplyBillDeliveryButton from './form/SupplyBillDeliveryButton'

const SupplyBillDeliveryItem = ({ delivery, index }) => {
  return (
    <TableRow>
        <TableCell align='center'>
            {
				index + 1
			}
            {
                ` (${delivery.id})`
            }
        </TableCell>
        <TableCell align='center'>
            {
				delivery.deliveryType ? delivery.deliveryType.name : ''
			}
        </TableCell>
        <TableCell align='center'>
            {
				delivery.ttn
			}
        </TableCell>
        <TableCell align='center'>
            {
				// statusDeliverText[delivery.status]
				<Status 
					status={delivery.status}
					text={statusDeliverText[delivery.status]}
				/>
			}
        </TableCell>
        <TableCell align='center'>
            {
				delivery.dateDeadline ? getDateOnlyUa(delivery.dateDeadline) : ''
			}
        </TableCell>
        {/* <TableCell align='center'>
            <ChangePriceBillItemButton 
                supplyBillItem={supplyBillItem}
            />
        </TableCell> */}
        {/* <TableCell align='center'>
            <div className='supplyAgrees'>
                <AgreeNachButton 
                    supplyBillItem={supplyBillItem}
                />
                <AgreeEconomistButton 
                    supplyBillItem={supplyBillItem}
                />
                <AgreeHeaderButton 
                    supplyBillItem={supplyBillItem}
                />
            </div>
        </TableCell> */}
        <TableCell align="center" className='myTable__actions'>
            <SupplyBillDeliveryButton
				// supplyBillId={supplyBillId}
				billDelivery={delivery}
			/>
        </TableCell>
    </TableRow>
  )
}

export default SupplyBillDeliveryItem